var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "review-widget-wrapper" },
    [
      _c("h2", [_vm._v(" Would you like to save the details you give us? ")]),
      _c("PiSecure"),
      _c("p", [
        _vm._v(
          " By selecting 'Save my details', you allow Service NSW to save and use your personal information. "
        )
      ]),
      _c("LearnMoreAccordion"),
      _c(
        "Button",
        { attrs: { secondary: "" }, on: { click: _vm.saveCustomerDetails } },
        [_vm._v(" Save my details ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }